module.exports = __webpack_public_path__ + "img/erp-logos_0006_unleashed.57fdc6c7.jpg";